export const HOME_CAROUSEL_MEDIA_EVENT = 'shuffledb:carousel-media-changed';
export const HOME_CAROUSEL_MEDIA_VERSION_KEY = 'shuffledb:carousel-media-version';

export function notifyHomeCarouselMediaChanged() {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(HOME_CAROUSEL_MEDIA_VERSION_KEY, String(Date.now()));
  } catch {
    // Storage can be unavailable in privacy modes; the same-tab event still works.
  }

  window.dispatchEvent(new Event(HOME_CAROUSEL_MEDIA_EVENT));
}
